import axios, { AxiosRequestConfig } from "axios";
import { getInitialBasePath } from "src/utils/BasePathTools";

export async function getTokenTools<T>(): Promise<T | any> {
  const options: AxiosRequestConfig = {
    method: "GET",
  };

  const url = `${getInitialBasePath()}/getToken`;

  try {
    const response = await axios(url, options);
    return await response.data;
  } catch (error) {
    throw new Error("Failed to fetch local tokens: ");
  }
}